import React from "react"

import Button, { ButtonProps } from "legacy/components/shared/Button"
import { Element, ElementProps } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"


interface OwnProps {
  buttonWidth?: string[]
  fallbackPid?: string
  fallbackCampaign?: string
  linkType?: string
  sizeVariant?: ButtonProps["sizeVariant"]
  text: string
  type?: string
  variant?: ButtonProps["variant"]
  url?: string
}

export type CallToActionProps = ElementProps & OwnProps

const CallToAction: React.FC<CallToActionProps> = ({
  bg,
  buttonWidth,
  color,
  fallbackCampaign = "Website",
  fallbackPid = "website",
  linkType,
  text,
  sizeVariant,
  type,
  url,
  variant,
  ...elementProps
}): React.ReactElement => {
  const isDownloadType = type === "download"
  const isDownloadUsesOwnLink = type === "download-own-link"

  const addAnalytics = (): void => {
    analytics.track("Download Button Clicked")
  }

  const button = (
    <Button
      bg={bg}
      color={color}
      fontSize={["16", "text.button"]}
      sizeVariant={sizeVariant}
      onClick={
        isDownloadType || isDownloadUsesOwnLink
          ? () => addAnalytics()
          : () => {}
      }
      width={buttonWidth}
      variant={variant}
    >
      {text}
    </Button>
  )

  return (
    <Element {...elementProps}>
      {isDownloadType || linkType !== "document" ? (
        <Element as="a" href={type === "download" ? url || "/app/" : url}>
          {button}
        </Element>
      ) : (
        <Link to={url}>{button}</Link>
      )}
    </Element>
  )
}

export default CallToAction
